import * as angular from 'angular';

import { ComponentDefinition, ScriptTestMode, Group, ReconciliationResults } from '../../models/';
import { IAuthorizationService } from '../../services/';
import { IScriptControl } from '../codeEditor/codeEditor.component';

class ScriptPanelController implements angular.IComponentController {
    canEdit: boolean;
    currentState: string;
    iReadOnly = false;
    isCodeEditorDisabled: boolean;
    isLoading: boolean;
    loadingMessage: string;
    modes = ScriptTestMode;
    reconciliationResults: ReconciliationResults;
    scriptCtrl: IScriptControl;
    selectedGroup: Group;

    static $inject = ['$state', 'authorizationService'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _authorizationService: IAuthorizationService) {
    }

    $onInit() {
        this.canEdit = this._authorizationService.canEdit();
        this.currentState = this._$state.current.name;
    }
}

export const wtScriptPanel: ComponentDefinition = {
    componentId: 'wtScriptPanel',
    controller: ScriptPanelController,
    template: require('./scriptPanel.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        selectedGroup: '=',
        scriptTestMode: '=',
        reconciliationResults: '=',
        isReadOnly: '=?',
        formCtrl: '=?',
        disableSave: '@?',
        isCodeEditorDisabled: '<',
        scriptCtrl: '=?'
    }
};
